import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-delete-client-account',
  templateUrl: './delete-client-account.component.html',
  styleUrls: ['./delete-client-account.component.css']
})
export class DeleteClientAccountComponent implements OnInit {

  innerHeight: number = window.innerHeight;


  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<DeleteClientAccountComponent>
  
  ) { }


  ngOnInit() {
   
  }

  
  closeDial(data?:any) {
    this.dialogRef.close(data);
  }
}
